import { render, staticRenderFns } from "./ListSkinCheckupProduct.vue?vue&type=template&id=35ed4dd1&scoped=true"
import script from "./ListSkinCheckupProduct.vue?vue&type=script&lang=js"
export * from "./ListSkinCheckupProduct.vue?vue&type=script&lang=js"
import style0 from "./ListSkinCheckupProduct.vue?vue&type=style&index=0&id=35ed4dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed4dd1",
  null
  
)

export default component.exports